export default __webpack_public_path__ + "static/media/ic-categories.990b2806.svg";